/* ============================================================
   Patio Door Parts theme JS
   - Theme toggle (dark / light / warm)
   - Scroll-based arrow carousels (reusable)
   - Nav hamburger menu
   - GA4 custom events (when Theme settings → Analytics ID is set)
   ============================================================ */

// ── Analytics bindings (PDPAnalytics defined early in snippets/ga4.liquid) ──
function initAnalyticsBindings() {
  if (!window.PDPAnalytics || typeof window.PDPAnalytics.track !== 'function') return;
  var track = function (name, params) {
    window.PDPAnalytics.track(name, params);
  };

  /* Search submit (header + search page) */
  document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"], input[type="search"]');
      var q = input ? String(input.value || '').trim() : '';
      track('search', { search_term: q });
    });
  });

  /* Search results / zero-results (search page) */
  var searchEmpty = document.querySelector('.search-empty');
  var searchCount = document.querySelector('.search-count-bar');
  if (searchEmpty || searchCount) {
    var termsEl = document.getElementById('search-input');
    var term = termsEl ? String(termsEl.value || '').trim() : '';
    if (searchEmpty) {
      track('search_zero_results', { search_term: term });
    } else if (searchCount) {
      var countText = searchCount.textContent || '';
      var countMatch = countText.match(/(\d+)/);
      track('view_search_results', {
        search_term: term,
        results_count: countMatch ? parseInt(countMatch[1], 10) : undefined
      });
    }
  }

  /* PDP add to cart */
  var addForm = document.getElementById('pdp-add-form');
  if (addForm) {
    addForm.addEventListener('submit', function () {
      var qty = document.getElementById('pdp-quantity');
      track('add_to_cart', {
        item_id: addForm.getAttribute('data-product-id') || undefined,
        quantity: qty ? parseInt(qty.value, 10) || 1 : 1,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined
      });
    });
  }

  /* Buy Now → treat as begin_checkout intent */
  var buyNow = document.getElementById('pdp-buy-now-btn');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      track('begin_checkout', {
        method: 'buy_now',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined
      });
    });
  }

  /* Fit how-to drawer opens */
  document.addEventListener('click', function (e) {
    var guide = e.target.closest('[data-fit-guide]');
    if (!guide) return;
    track('fit_guide_open', { guide: guide.getAttribute('data-fit-guide') || 'wheel' });
  });

  /* Contact form success is fired from netsuite-case.js via PDPAnalytics */
}

// ── Theme Toggle ─────────────────────────────────────────
const THEMES = ['dark', 'light', 'warm'];

function setTheme(name) {
  document.documentElement.setAttribute('data-theme', name);
  localStorage.setItem('ah-theme', name);
  document.querySelectorAll('.theme-dot').forEach(dot => {
    const isActive = dot.dataset.theme === name;
    dot.classList.toggle('active', isActive);
    dot.setAttribute('aria-pressed', String(isActive));
  });
}

function initThemeToggle() {
  const saved = localStorage.getItem('ah-theme') || 'dark';
  document.documentElement.setAttribute('data-theme', saved);

  document.querySelectorAll('.theme-dot').forEach(dot => {
    const isActive = dot.dataset.theme === saved;
    dot.classList.toggle('active', isActive);
    dot.setAttribute('aria-pressed', String(isActive));
    dot.addEventListener('click', () => setTheme(dot.dataset.theme));
  });
}

// ── Nav Hamburger ─────────────────────────────────────────
function initNav() {
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  if (!hamburger || !mobileMenu || hamburger.getAttribute('data-pdp-bound') === '1') return;

  let previouslyFocused = null;

  function getFocusable() {
    return Array.from(
      mobileMenu.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true');
  }

  function openMenu() {
    previouslyFocused = document.activeElement;
    mobileMenu.classList.add('open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.setAttribute('aria-label', 'Close navigation menu');
    hamburger.innerHTML = '<svg aria-hidden="true" focusable="false" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="4" y1="4" x2="20" y2="20"/><line x1="20" y1="4" x2="4" y2="20"/></svg>';
    document.documentElement.style.overflow = 'hidden';
    const firstLink = mobileMenu.querySelector('a, button');
    if (firstLink) firstLink.focus();
  }

  function closeMenu() {
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.setAttribute('aria-label', 'Open navigation menu');
    hamburger.innerHTML = '<svg aria-hidden="true" focusable="false" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
    document.documentElement.style.overflow = '';
    const restore = previouslyFocused && document.contains(previouslyFocused)
      ? previouslyFocused
      : hamburger;
    restore.focus();
    previouslyFocused = null;
  }

  hamburger.addEventListener('click', () => {
    mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
  });

  /* Close on link click (but not theme dots) */
  mobileMenu.querySelectorAll('a').forEach(el => {
    el.addEventListener('click', closeMenu);
  });

  /* Focus trap + Escape while open */
  document.addEventListener('keydown', (e) => {
    if (!mobileMenu.classList.contains('open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeMenu();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = getFocusable();
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
}

// ── Scroll Carousel ───────────────────────────────────────
// Generic: finds [data-carousel] containers and wires up arrow + dot controls.
// HTML structure expected:
//   <div data-carousel>
//     <div data-carousel-track>  ← scrollable flex container
//       <div data-carousel-item>...</div>
//       ...
//     </div>
//     <button data-carousel-prev>‹</button>
//     <button data-carousel-next>›</button>
//     <div data-carousel-dots></div>  ← optional
//   </div>

function initCarousel(container) {
  const track = container.querySelector('[data-carousel-track]');
  const prevBtn = container.querySelector('[data-carousel-prev]');
  const nextBtn = container.querySelector('[data-carousel-next]');
  const dotsContainer = container.querySelector('[data-carousel-dots]');
  if (!track || !prevBtn || !nextBtn) return;

  let currentIndex = 0;

  function getCardWidth() {
    const first = track.children[0];
    if (!first) return 0;
    const style = window.getComputedStyle(track);
    const gap = parseFloat(style.gap) || 12;
    return first.offsetWidth + gap;
  }

  function getVisibleCount() {
    const first = track.children[0];
    if (!first) return 1;
    return Math.round(track.offsetWidth / first.offsetWidth) || 1;
  }

  function getMaxIndex() {
    return Math.max(0, track.children.length - getVisibleCount());
  }

  function goTo(index) {
    currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
    track.scrollTo({ left: currentIndex * getCardWidth(), behavior: 'smooth' });
    updateUI();
  }

  function updateUI() {
    const max = getMaxIndex();
    prevBtn.classList.toggle('enabled', currentIndex > 0);
    nextBtn.classList.toggle('enabled', currentIndex < max);

    if (dotsContainer) {
      dotsContainer.querySelectorAll('.carousel-dot').forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex);
      });
    }
  }

  function buildDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = '';
    const max = getMaxIndex();
    for (let i = 0; i <= max; i++) {
      const dot = document.createElement('button');
      dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => goTo(i));
      dotsContainer.appendChild(dot);
    }
  }

  prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
  nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

  // sync index when user scrolls manually (touch)
  track.addEventListener('scroll', () => {
    const cardW = getCardWidth();
    if (cardW > 0) {
      currentIndex = Math.round(track.scrollLeft / cardW);
      updateUI();
    }
  }, { passive: true });

  buildDots();
  updateUI();

  // rebuild on resize
  const ro = new ResizeObserver(() => { buildDots(); updateUI(); });
  ro.observe(container);
}

function initAllCarousels() {
  document.querySelectorAll('[data-carousel]').forEach(initCarousel);
}

// ── Hero featured-product carousel (transform-based) ──────
// The hero uses a single-slide transform carousel (not scroll-based)
// so product images fill the full card nicely.

function initHeroCarousel() {
  const wrap = document.querySelector('[data-hero-carousel]');
  if (!wrap) return;

  const slides = wrap.querySelectorAll('[data-hero-slide]');
  const prevBtn = wrap.querySelector('[data-hero-prev]');
  const nextBtn = wrap.querySelector('[data-hero-next]');
  const dotsWrap = wrap.querySelector('[data-hero-dots]');
  const slidesTrack = wrap.querySelector('[data-hero-track]');
  if (!slides.length) return;

  let current = 0;
  const total = slides.length;

  function renderDots() {
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Product ${i + 1}`);
      dot.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(dot);
    });
  }

  function goTo(index) {
    current = (index + total) % total;
    if (slidesTrack) {
      slidesTrack.style.transform = `translateX(-${current * 100}%)`;
    }
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.carousel-dot').forEach((d, i) => {
        d.classList.toggle('active', i === current);
      });
    }
    if (prevBtn) prevBtn.disabled = false;
    if (nextBtn) nextBtn.disabled = false;
  }

  if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

  renderDots();
}

// ── Footer full-width fix ─────────────────────────────────
// Walks up from .site-footer and strips any max-width / padding
// constraints the Next theme applies to section group wrappers.
function initFooterLayout() {
  var footer = document.querySelector('.site-footer');
  if (!footer) return;

  // Only target the direct Shopify section wrapper(s) around the footer,
  // not the full ancestor chain which could break other page sections.
  var el = footer.parentElement;
  var steps = 0;
  while (el && el !== document.body && steps < 3) {
    var tag = el.tagName.toLowerCase();
    // Stop at main content containers — don't strip their layout
    if (tag === 'main' || el.id === 'content' || el.id === 'root') break;
    el.style.setProperty('max-width', 'none', 'important');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('padding-left', '0', 'important');
    el.style.setProperty('padding-right', '0', 'important');
    el.style.setProperty('margin-left', '0', 'important');
    el.style.setProperty('margin-right', '0', 'important');
    el = el.parentElement;
    steps++;
  }
}

// ── Init ──────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  initThemeToggle();
  initNav();
  initHeroCarousel();
  initAllCarousels();
  initFooterLayout();
  initAnalyticsBindings();
});
